<button class="w-full max-w-full sm:max-w-none flex border border-gray-200 p-4 items-start cursor-pointer hover:bg-afcu-navy-50" (click)="goTo()">
  <div class="flex flex-col gap-0 w-full">
    <div class="text-afcu-navy-800 font-bold text-base w-fit">{{title}}</div>
    <div class="text-black text-base font-normal text-start">{{description}}</div>
    @if(duration) {
      <div class="pt-2">
      <div class="bg-gray-100 py-0.5 px-2.5 flex gap-1 text-xs font-semibold w-fit">
        <img src="/icons/clock.svg" height="11" width="11"/>
        <div>{{duration}} {{getText()}}</div>
      </div>
    </div>
    }
  </div>
  <img src="/icons/arrow/blue-hat.svg" />
</button>